import { render, staticRenderFns } from "./Ordenanzas.vue?vue&type=template&id=5e66ed80&scoped=true&"
import script from "./Ordenanzas.vue?vue&type=script&lang=ts&"
export * from "./Ordenanzas.vue?vue&type=script&lang=ts&"
import style0 from "./Ordenanzas.vue?vue&type=style&index=0&id=5e66ed80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e66ed80",
  null
  
)

export default component.exports